/**
 * Scoped Bootstrap form-controls styling (checkboxes + switches).
 * Wrap a subtree with class `onehub-brand-form-controls`.
 *
 * MDB renders switch thumbs as `.form-switch .form-check-input::after` (not Bootstrap’s SVG).
 */
export const ONEHUB_BRAND_HEX = "var(--color-primary, #083B4C)";

export const ONEHUB_BRAND_FORM_CONTROLS_CSS = `
.onehub-brand-form-controls {
  --oh-brand-form: ${ONEHUB_BRAND_HEX};
  --oh-brand-form-focus: rgba(8, 59, 76, 0.28);
}

/* Checked checkboxes / radios — solid brand fill (Bootstrap defaults to theme blue). */
.onehub-brand-form-controls .form-check-input:checked {
  background-color: var(--oh-brand-form) !important;
  border-color: var(--oh-brand-form) !important;
}

/* Switch track geometry (MDB + our ::after thumbs). */
.onehub-brand-form-controls .form-switch .form-check-input[type="checkbox"] {
  width: 2em !important;
  height: 0.95em !important;
  border-radius: 2em !important;
  margin-block-start: 0.125em !important;
}

/* MDB: thumb is ::after — white knob off + on; track reads grey / brand. */
.onehub-brand-form-controls .form-switch .form-check-input[type="checkbox"]::after {
  width: 0.75rem !important;
  height: 0.75rem !important;
  margin-top: 2px !important;
  box-shadow:
    0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
  transition: background-color 0.2s, transform 0.2s !important;
}

.onehub-brand-form-controls .form-switch .form-check-input[type="checkbox"]:not(:checked):not(:indeterminate)::after {
  background-color: #fff !important;
}

.onehub-brand-form-controls .form-switch .form-check-input:checked[type="checkbox"]::after {
  background-color: #fff !important;
  margin-left: 1.0625rem !important;
}

.onehub-brand-form-controls .form-switch .form-check-input:focus[type="checkbox"]::after {
  width: 0.75rem !important;
  height: 0.75rem !important;
}

/* Solid brand track when on (no SVG knob — ::after handles thumb). */
.onehub-brand-form-controls .form-switch .form-check-input:checked,
.onehub-brand-form-controls .form-switch .form-check-input:checked:focus,
.onehub-brand-form-controls .form-switch .form-check-input:checked:focus-visible {
  background-color: var(--oh-brand-form) !important;
  border-color: var(--oh-brand-form) !important;
  background-image: none !important;
}

.onehub-brand-form-controls .form-switch .form-check-input:focus:not(:checked):not(:indeterminate) {
  background-image: none !important;
}

/* MDB ::before focus halo — replace #3b71ca with brand when checked */
.onehub-brand-form-controls .form-switch .form-check-input:checked:focus::before {
  margin-left: 1.0625rem !important;
  box-shadow: 3px -1px 0 13px rgba(8, 59, 76, 0.38) !important;
}

.onehub-brand-form-controls .form-check-input:focus {
  border-color: var(--oh-brand-form);
  outline: 0;
  box-shadow: 0 0 0 0.25rem var(--oh-brand-form-focus);
}
`;
